export const css = {
	root: '_1qRMFEps',
	videoInstructions: 'rIeL983z',
	videoWrapper: '_3-IN7fak',
	videoTranscript: '_2rL7cmh0',
	' _key': 'certwise-theme/certwise/video/video'
};

export default css;
